import classnames from "classnames";

import Box from "@mui/material/Box";
import Step from "@mui/material/Step";
import Stepper from "@mui/material/Stepper";
import StepLabel from "@mui/material/StepLabel";

interface IStepper {
  steps: Array<{ title: string; description: string; disabled?: boolean }>;
  activeStep: number;
  setActiveStep: (val: number) => void;
}

const StepperComponent = ({ steps, activeStep, setActiveStep }: IStepper) => {
  return (
    <Box sx={{ width: "100%" }}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map(({ title, description, disabled = false }, index) => (
          <Step
            key={title}
            active={true}
            disabled={disabled}
            className={classnames({
              "stepper-disabled": disabled,
              "stepper-active": index === activeStep,
            })}
          >
            <StepLabel>
              {title}
              <span>{description}</span>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default StepperComponent;
